import { INPUT_AUTOCOMPLETE, INPUT_TYPE, schemas } from '@nandosaus/constants';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Alert } from '../../alert';
import { analytics } from '../../../analytics';
import { Box } from '../../grid';
import { Form } from '../../form';
import { FormikTextInput } from '../../input';
import { Link } from '../../link';
import { navigation } from '../../../constants';
import { P } from '../../typography';
import { setLandingPage } from '../../../utils/auth';

const SignIn = ({ error, setError, setMfa, signIn, showAlert, headingText, landingPage, hideCreateAccountLink }) => {
  const [signedIn, setSignedIn] = useState(false);
  return (
    <Form
      bottomElement={
        hideCreateAccountLink ? null : (
          <Box py={1} mt="1rem" textAlign="center">
            <P variant={3}>
              Don’t have an account?{' '}
              <Link
                variant={3}
                href={navigation.CREATE_ACCOUNT}
                onClick={() => {
                  if (!landingPage) {
                    return;
                  }
                  analytics.track('User Sign Up Clicked', {
                    location: 'Sign In',
                  });
                  setLandingPage(landingPage);
                }}
              >
                Create account
              </Link>
            </P>
          </Box>
        )
      }
      bottomPadding={hideCreateAccountLink ? 1 : undefined}
      submitted={signedIn}
      initialValues={{ email: '', password: '' }}
      onSubmit={async ({ email, password }) => {
        document.activeElement.blur();

        try {
          analytics.track('User Sign In Submitted');

          const { user } = await signIn({ email, password });
          // TODO: handle redirect for no mobile
          if (user.challengeName === 'SMS_MFA') {
            setError(null);
            setMfa({ user, email, password });
            analytics.track('User Multi-Factor Auth Submitted');
          } else {
            setError(null);
            setSignedIn(true);
          }
        } catch (err) {
          analytics.track('User Sign In Failed', { failureReason: err.message });
          setError(err.message);
        }
      }}
      buttonText="Sign in"
      error={error}
      heading={headingText}
      validationSchema={schemas.signIn}
    >
      {showAlert && (
        <Box mb={1}>
          <Alert data-testid="account-verification-sms-alert" type="info">
            We’ve sent your account verification link via SMS. Please verify your account before you sign in.
          </Alert>
        </Box>
      )}
      <Box mb={1}>
        <FormikTextInput name="email" label="Email" type={INPUT_TYPE.EMAIL} autoComplete={INPUT_AUTOCOMPLETE.EMAIL} />
      </Box>
      <Box mb="0.5rem">
        <FormikTextInput
          type={INPUT_TYPE.PASSWORD}
          name="password"
          label="Password"
          autoComplete={INPUT_AUTOCOMPLETE.PASSWORD}
        />
      </Box>
      <Box mt={1} textAlign="center" mb={2}>
        <Link
          variant={3}
          href={navigation.FORGOT_PASSWORD}
          onClick={() => analytics.track('User Reset Password Clicked')}
        >
          Forgotten password?
        </Link>
      </Box>
    </Form>
  );
};

SignIn.propTypes = {
  error: PropTypes.string,
  setError: PropTypes.func.isRequired,
  setMfa: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
  showAlert: PropTypes.bool,
  headingText: PropTypes.string,
  landingPage: PropTypes.string,
  hideCreateAccountLink: PropTypes.bool,
};

SignIn.defaultProps = {
  error: null,
  showAlert: false,
  headingText: 'Sign in to your account',
  landingPage: null,
  hideCreateAccountLink: false,
};

export { SignIn };
